import styled from 'styled-components'
import { DolaThemes } from '../../../styles/types'
import { iPadDown, iPadUp } from '../../../styles/mediaQueries'
import {
  borderRadius,
  borderWidth,
  mobileFontSize,
} from '../../../styles/variables'
import { ButtonOptions, ButtonSizes, ButtonVariants } from '../types'
import theme from './theme'

const buttonSize: Record<ButtonSizes, string> = {
  large: `
        height: 3.75vw;
        padding: 0 2.74vw;
        min-width: 18.75vw;
    
        ${iPadDown} {
            height: 11.6vw;
            padding: 0 7.25vw;
        }
    `,
  medium: `
        height: 3.75vw;
        padding: 0 2.74vw;
    
        ${iPadDown} {
            height: 11.6vw;
            padding: 0 7.25vw;
        }
    `,
  small: `
        height: 2vw;
        min-width: 5vw;
        padding: 0 0.62vw;
        ${iPadDown} {
            height: 6.5vw;
            min-width: 15.46vw;
            padding:0 1.94vw;
        }
`,
}

const smallButtonFontSize = `
    font-size: 0.92vw;
    ${iPadDown} {
      font-size: 3vw;
    }
`

const uppercaseButtonFontSize = `
    font-size: 0.98vw;
    ${iPadDown} {
      font-size: 3.38vw;
    }
`

const defaultButtonFontSize = `
    font-size: 1.33vw;
    ${iPadDown} {
      font-size: ${mobileFontSize}
    }
`

interface ButtonProps extends Omit<ButtonOptions, 'variant'> {
  dolaTheme: DolaThemes
  fullWidth: boolean
  uppercase?: boolean
  variant?: ButtonVariants
}

const Button = styled.button<ButtonProps>`
  box-shadow: none;
  border-style: solid;
  cursor: pointer;
  font-family: 'Whyte Trial', Arial, Helvetica, sans-serif;
  font-weight: ${({ uppercase }) => (uppercase ? 'bold' : '500')};
  justify-content: center;
  margin: 0;
  outline: none;
  position: relative;
  transition: transform 0.1s ease-out;
  -webkit-appearance: none;
  ${borderRadius};
  ${borderWidth};
  ${({ size = 'medium' }) => buttonSize[size]};
  ${({ dolaTheme, variant = 'primary' }) => `
      background: ${theme[dolaTheme][variant].background};
      border-color: ${theme[dolaTheme][variant].border};
      color: ${theme[dolaTheme][variant].text};
      `}
  ${({ uppercase, size }) => {
    if (size === 'small') {
      return smallButtonFontSize
    }

    if (uppercase) {
      return uppercaseButtonFontSize
    }

    return defaultButtonFontSize
  }}
  ${({ fullWidth }) =>
    fullWidth
      ? `
    width: 100%;
  `
      : ''}

  ${iPadDown} {
    line-height: 1.2;
    text-align: center;
    width: 100%;
  }

  ${({ uppercase }) =>
    uppercase
      ? 'text-transform : uppercase'
      : `
    letter-spacing: -1px;
    -webkit-font-smoothing: antialiased;
`};

  &:hover,
  &:focus {
    transform: translate(0.3vw, -0.3vw);

    ${iPadDown} {
      transform: translate(0.93vw, -0.93vw);
    }
  }

  &:active {
    ${iPadUp} {
      transform: translate(0, 0) !important;
    }
  }

  &:disabled {
    cursor: not-allowed;
    transform: none;
  }
`

export default Button
